var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Checkout__Messages"},_vm._l((_vm.Notifications),function(message,index){return _c('el-alert',{key:index,attrs:{"type":message.type || 'info',"description":message.message},on:{"close":function($event){return _vm.handleClose(message)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }